import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table.tsx";
import { Button } from "@/components/ui/button.tsx";
import { ChevronDown } from "lucide-react";
import { formatNumber } from "@/lib/utils.ts";

interface DataPoint {
  rpm: number;
  torque: number;
  horsepower: number;
  gear: string;
}

interface DataTableProps {
  data: DataPoint[];
  measurement: 'metric' | 'imperial';
}

export const DataTable = ({ data, measurement }: DataTableProps) => {
  const [showAll, setShowAll] = useState(false);
  const rowsToShow = showAll ? data.length : 25;

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>RPM</TableHead>
            <TableHead>Torque ({measurement === 'metric' ? 'Nm' : 'lb-ft'})</TableHead>
            <TableHead>Horsepower (hp)</TableHead>
            <TableHead>Gear</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.slice(0, rowsToShow).map((row, index) => (
            <TableRow key={index}>
              <TableCell>{formatNumber(row.rpm)}</TableCell>
              <TableCell>{formatNumber(row.torque)}</TableCell>
              <TableCell>{formatNumber(row.horsepower)}</TableCell>
              <TableCell>{row.gear}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {data.length > 25 && !showAll && (
        <div className="flex justify-center py-2 border-t">
          <Button
            variant="ghost"
            size="sm"
            className="text-xs text-muted-foreground hover:text-primary"
            onClick={() => setShowAll(true)}
          >
            Click to view more entries
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
};
